export const NOT_APPLICABLE = 'Not Applicable';
export const GROUP_PREFIX = 'GROUP';
